// @ts-nocheck
import Layout from "../components/Layout"
import { Box, Stack, Avatar, Breadcrumbs, Grid2 as Grid, Divider, Chip, Button, IconButton, Fab } from "@mui/material"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { useParams, useNavigate } from "react-router-dom"
import { InfoRounded, Edit, Info, Trash, People } from "@mui/icons-material"
import DialogForm from "../components/DialogForm"
import { useSnackbarMessage } from "../hooks/snackbar"
import { DataField, DataRow } from "../components/DataField"
import { SectionTitle } from "../components/SectionTitle"
import { PageTitle } from "../components/PageTitle"
import { useTranslation } from "react-i18next"
import FormatDate from "../components/FormatDate"
import RecordInfo from "../components/RecordInfo"
import DeleteBar from "../components/DeleteBar"
import DialogConfirm from "../components/DialogConfirm"
import { Donatore } from "../types"
import { usePersona, usePersonaDelete, usePersonaHistory, usePersonaUpdate } from "../hooks/persone"
import PersonaForm from "../components/forms/PersonaForm"
import { useDesiredHeight } from "../hooks/measuring"

export default function PersonaDettaglio() {
  const { id } = useParams()
  const { t, i18n } = useTranslation()
  const { data: persona, refetch } = usePersona(parseInt(id as string))

  const [updateModalState, updateModalActions] = useModalTrigger()
  const [deleteModalState, deleteModalActions] = useModalTrigger()

  const { mutateAsync: update } = usePersonaUpdate()
  const { mutateAsync: remove } = usePersonaDelete()

  const showMessage = useSnackbarMessage()
  const navigate = useNavigate()

  const historyBag = usePersonaHistory(id)
  const { ref, desiredHeight } = useDesiredHeight(24)

  return (
    <Layout>
      <Stack sx={{ height: "100%", overflow: "hidden" }}>
        <PageTitle
          padding
          border
          title={persona?.nome}
          breadcrumbs={[
            {
              label: "Persone",
              iconType: People,
              to: "/persone",
            },
            {
              label: persona?.nome,
            },
          ]}
        />

        <Grid
          container
          spacing={2}
          sx={{
            overflow: "auto",
            height: "100%",
            p: 3,
            pt: 2,
          }}
        >
          <Grid
            size={{
              xs: 12,
              xl: 12,
            }}
          >
            <Stack
              flexGrow={1}
              sx={{
                height: "fit-content",
                position: "relative",
                bgcolor: "white",
                boxShadow: 1,
              }}
            >
              <SectionTitle
                first
                title={t("persona.dati_della_persona")}
                onEdit={() => {
                  updateModalActions.open()
                }}
              />
              <Box px={3} pb={2}>
                <DataRow>
                  <DataField label={t("persona.nome")} value={persona?.nome} size={3} />
                  <DataField
                    label={t("persona.data_nascita")}
                    value={persona?.data_nascita ? <FormatDate>{persona.data_nascita}</FormatDate> : "xx"}
                    size={3}
                  />
                  <DataField
                    label={t("persona.data_morte")}
                    value={persona?.data_morte ? <FormatDate>{persona.data_morte}</FormatDate> : ""}
                    size={3}
                  />
                </DataRow>

                <DataRow>
                  <DataField label={t("persona.biografia")} value={persona?.biografia} size={12} />
                </DataRow>
                <DataRow last>
                  <DataField label={t("persona.note")} value={persona?.note} size={{xs:12, xl: 8}} />
                </DataRow>
              </Box>
            </Stack>
          </Grid>
          <Grid
            size={{
              xs: 12,
              xl: 12,
            }}
          >
            <Stack
              ref={ref}
              sx={{
                bgcolor: "grey.200",
                borderRadius: 1,
                boxShadow: 1,
                
              }}
            >
              <SectionTitle bgcolor="grey.700" info />
              <Stack sx={{ p: 2 }} flexGrow={1}>
                <RecordInfo
                  first_update={persona?.first_update}
                  last_update={persona?.last_update}
                  historyBag={historyBag}
                />
              </Stack>
              <DeleteBar title={t("persona.cta_elimina")} onDelete={() => deleteModalActions.open(persona)} />
            </Stack>
          </Grid>
        </Grid>
      </Stack>

      <DialogForm<Persona>
        open={updateModalState.isOpen}
        handleClose={updateModalActions.close}
        FormComponent={PersonaForm}
        title={t("persona.cta_modifica")}
        save={(values) => {
          return update(values).then(() => {
            updateModalActions.close()
            refetch()
            showMessage(t("persona.esito_modifica_ok"))
          })
        }}
        item={persona}
        hasCancel
      />

      <DialogConfirm
        open={deleteModalState.isOpen}
        handleClose={deleteModalActions.close}
        title={t("persona.cta_elimina")}
        subtitle={
          <span>
            {t("persona.cta_subtitle_elimina")} <b>"{deleteModalState.value?.nome}"</b>&nbsp;?
          </span>
        }
        textConfirm={t("general.elimina")}
        onConfirm={() => {
          return remove(deleteModalState.value.id).then(() => {
            deleteModalActions.close()
            showMessage(t("persona.esito_elimina_ok"))
            navigate(`/${i18n.language}/persone`)
          }).catch(() => {
            deleteModalActions.close()
            showMessage(t("general.esito_elimina_errore"), "error")
          })
        }}
      />
    </Layout>
  )
}
